import React from 'react';

import ourCustomersStyles from './ourCustomersStyles';
import { Box, Typography } from '@mui/material';
import PartnerList from '../../components/PartnerList';
import { OurCustomersTemplateData } from '.';
import Tout from '../../components/Tout';

const OurCustomersTemplate: React.FC<OurCustomersTemplateData> = ({
  distributors,
  textContent,
  title,
}) => {
  const { classes } = ourCustomersStyles();

  return (
    <main>
      <section className={classes.mainWrapper}>
        <Box className={classes.sideNav}>
          <nav>
            <PartnerList />
          </nav>
        </Box>
        <Box className={classes.mainContentWrapper}>
          <Typography variant="h4">{textContent.title}</Typography>
          <Box className={classes.mainContent}>
            <article>
              {textContent.main.map((content, idx) => (
                <Box mb={4} key={`tout_${idx}`}>
                  <Tout
                    bodyText={content}
                    bodyTextVariant="body1"
                    bodyTextColor="MenuText"
                    imageUrl={textContent.images?.[idx]}
                    flexDirection={idx % 2 ? 'row-reverse' : 'row'}
                  />
                </Box>
              ))}
            </article>
            {/* <img className={classes.mainImage} src={iceCream} alt="ice-cream" /> */}
            {/* <a href="https://www.vecteezy.com/free-photos/dessert">
              Dessert Stock photos by Vecteezy
            </a> */}
          </Box>
        </Box>
      </section>
    </main>
  );
};

export default OurCustomersTemplate;
